export default class GroupModel {
  name = ''
  count = 0
  item = null
  own = true
  contacts = []
}
